import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { getTaseron } from '../../../../services/getTaseron'
import { CheckBox } from 'devextreme-react'
import useFormatMessage from '../../../../utils/useFormatMessage'
export default function Taseron({ employeeDetail }) {

  const [taseron, setTaseron] = useState([])
  const { t } = useFormatMessage();

  useEffect(() => {
    (async () => {
      const data = await getTaseron();
      setTaseron(data);
    })();

  }, [])


  return (

    <Row className='mb-2'>
      <Col sm="12">
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col xl="11" className='mb-3' style={{ width: "750px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>
            <div style={{ fontSize: "15px", color: 'white', textAlign: "center", verticalAlign: "center" }}>{t("Taşeron Adları")}</div>
          </Col>
        </Row>
        <Row>
          {taseron && taseron.map((item) => (
            <Col
              className='taseronCol'
              id={`taseronCol-${item.id}`}
              sm='4'
              md='3'
              style={{ marginBottom: '10px' }}
              key={item.id} >
              <CheckBox
                defaultValue={employeeDetail?.subcontractor_ids?.includes(item.id) || false}
                text={item.name}

              />

            </Col>

          ))}
        </Row>
      </Col>
    </Row>
  )
}

